import React, { useRef, useState, useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import {
  Grid,
  Typography,
  Box
} from '@mui/material'
import { Save } from '@mui/icons-material'

import DialogFullScreen from './DialogFullScreen'
import CustomTextField from '../atoms/CustomTextField'
import RichTextEditor from '../../lexical/RichTextEditor'

const EmailEditDialog = (props) => {
  const {
    open,
    onSave,
    handleClose,
    contactData,
    firmData,
    saving = false
  } = props

  const { t } = useTranslation()

  const exportHtmlRef = useRef()
  const contentRef = useRef()

  const [subject, setSubject] = useState('')
  const [subjectErr, setSubjectErr] = useState(false)

  const fullName = contactData
    ? `${contactData.firstName || ''} ${contactData.lastName || ''}`.trim()
    : ''
  const isUnknownContact = contactData && !fullName
  const contactName = fullName || contactData?.emailAddress || t('mailTemplate.employeeSelection.unknownContact')

  const handleSubmit = () => {
    if (!subject) {
      setSubjectErr(true)
    } else {
      const exportedHtml = exportHtmlRef.current.exportHtml()

      onSave({
        firmId: firmData?.id,
        contactId: contactData?.id,
        subject,
        html: exportedHtml
      })
    }
  }

  useEffect(() => {
    if (open && contactData) {
      setSubject(contactData?.emailSubject || '')
      setSubjectErr(false)
    }
  }, [open, contactData])

  useEffect(() => {
    if (open) {
      const scrollToTop = () => {
        if (contentRef.current) {
          contentRef.current.scrollTop = 0
        }
      }

      scrollToTop()

      const timer1 = setTimeout(scrollToTop, 150)

      const timer2 = setTimeout(scrollToTop, 200)

      return () => {
        clearTimeout(timer1)
        clearTimeout(timer2)
      }
    }
  }, [open])

  const dialogTitle = firmData && contactData
    ? `${t('mailTemplate.wizard.firmList.editEmail')} - ${firmData?.name || ''} - ${contactName}`
    : `${t('mailTemplate.wizard.firmList.editEmail')}`

  return (
    <DialogFullScreen
      open={open}
      handleClose={handleClose}
      onSubmit={handleSubmit}
      btnText={t('mailTemplate.wizard.rte.saveBtn')}
      btnIcon={<Save/>}
      loading={saving}
      title={dialogTitle}
      contentRef={contentRef}
      submitDisabled={saving || subjectErr}
    >
      {contactData && (
        <Box sx={{ px: 2, py: 1, backgroundColor: 'rgba(0, 0, 0, 0.02)', borderBottom: '1px solid rgba(0, 0, 0, 0.08)' }}>
          <Typography variant="body2" color="text.secondary">
            {t('mailTemplate.campaignReview.editingEmailFor')}:{' '}
            <strong style={{ fontStyle: isUnknownContact ? 'italic' : 'normal' }}>{contactName}</strong>
            {contactData.position && ` (${contactData.position})`}
          </Typography>
        </Box>
      )}
      <Grid container spacing={2} className='p-2'>
        <Grid item xs={12}>
          <CustomTextField
            fullWidth
            placeholder={t('mailTemplate.mailbox.email.subject')}
            value={subject}
            onChange={(e) => {
              setSubject(e.target.value)
              if (e.target.value && subjectErr) {
                setSubjectErr(false)
              }
            }}
            error={subjectErr}
            helperText={subjectErr ? t('mailTemplate.mailbox.email.subjectErr') : null}
          />
        </Grid>
      </Grid>
      <div className="email-display-spacing">
        <RichTextEditor templateHtml={contactData?.emailContent || ''} ref={exportHtmlRef}/>
      </div>
    </DialogFullScreen>
  )
}

export default EmailEditDialog
